module.exports = __webpack_public_path__ + "static/media/score.d15b3ec5.svg";